import React from 'react';
import { IconButton } from '../core/IconButton.jsx';

/** Skip control. 边角聊 convention: forward 10s, back 5s. */
export function SkipButton({ direction = 'forward', size = 'md', onSkip, ...rest }) {
  const forward = direction === 'forward';
  const seconds = forward ? 10 : 5;
  return (
    <IconButton
      icon={forward ? 'forward_10' : 'replay_5'}
      label={forward ? '前进 10 秒' : '后退 5 秒'}
      size={size}
      onClick={() => onSkip && onSkip(forward ? seconds : -seconds)}
      {...rest}
    />
  );
}
